<template>
	<div class="non-bind-mask">
		<div class="mask-content">
			<img src="@/assets/qualificationQuery/vip_icon.png" alt="" />
			<p>您尚未绑定企业，请先绑定企业后查看</p>
			<router-link to="/user/common/company">
				立即绑定
				<i class="el-icon-arrow-right"></i>
			</router-link>
		</div>
	</div>
</template>

<script>
	// 未绑定企业提示
	export default {
		name: 'NonbindEnterprise',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
